import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const OrganisatorApi = {
	get(tochtId) {
		const accountParamUrl = prependRoot("organisator/" + tochtId, getApiRoot());
		return axios.get(accountParamUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	save(model) {
		const serviceUrl = prependRoot('organisator/', getApiRoot());
		return axios.put(serviceUrl,
			model
			,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default OrganisatorApi;